import { render, staticRenderFns } from "./ISFDetail.vue?vue&type=template&id=418fa478&"
import script from "./ISFDetail.vue?vue&type=script&lang=js&"
export * from "./ISFDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports